import { render, staticRenderFns } from "./Laopachachon.vue?vue&type=template&id=1160a9b3&"
import script from "./Laopachachon.vue?vue&type=script&lang=js&"
export * from "./Laopachachon.vue?vue&type=script&lang=js&"
import style0 from "./Laopachachon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports